import { Ref } from 'vue';

import { DetailsHolder } from '../composables/details-holder';
import { BuildingDto, BuildingSection, UnitDefaultSection } from '../dtos/building.dto.interface';

/**
 * The building page's holder: the shared forms read the building and save on it. A shared section
 * reaches every unit; a unit default only changes what the next unit starts with.
 */
export function buildingDetailsHolder(
  building: Ref<BuildingDto | undefined>,
  saveShared: (section: BuildingSection, values: object) => Promise<unknown>,
  saveDefault: (section: UnitDefaultSection, values: object) => Promise<unknown>,
): DetailsHolder {
  return {
    kind: 'building',
    get details() {
      return building.value;
    },
    saveLocation: (payload) => saveShared('location', payload),
    saveAmenities: (payload) => saveShared('amenities', payload),
    saveParking: (payload) => saveShared('parking', payload),
    saveAccessibility: (payload) => saveShared('accessibility', payload),
    saveRenterRequirements: (payload) => saveDefault('renterRequirements', payload),
    savePetPolicy: (payload) => saveDefault('petPolicy', payload),
    saveLeaseConditions: (payload) => saveDefault('leaseConditions', payload),
    saveTourTypes: ({ allowsInPersonTours, allowsVirtualTours, allowsSelfGuidedTours }) =>
      saveDefault('tourTypes', {
        allowsInPersonTours,
        allowsVirtualTours,
        allowsSelfGuidedTours: allowsSelfGuidedTours ?? false,
      }),
  };
}
